import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Grid2 as Grid,
  Typography,
  ButtonGroup,
  Button,
  IconButton,
  Card,
  Chip,
  Stack,
  Alert,
  AlertTitle,
  useTheme
} from '@mui/material';
import {
  Code as CodeIcon,
  Category as CategoryIcon,
  Report as ReportIcon
} from '@mui/icons-material';

// const encodingDisplayTypographySx = {
//   whiteSpace: 'nowrap',
//   overflow: 'hidden',
//   textOverflow: 'ellipsis'
// };

function HccDisplayInfo({
  code,
  description,
  estimatedImpactDollars,
  type,
  version,
  theme
}) {
  return (
    <>
      <Alert
        color="info"
        sx={{ marginTop: '8px' }}
        icon={<CategoryIcon sx={{ color: theme.palette.info.dark }}/>}
      >
        <AlertTitle>
          HCC {code} || MODELVERSION {version}
        </AlertTitle>
        <Typography
          variant="body2"
          title={description}
        >
          {description}
        </Typography>
      </Alert>
    </>
  );
}

function DxDisplayInfo({ code, description, hccs, theme, hasGuidance }) {
  return (
    <>
      <Alert
        color="warning"
        icon={<CodeIcon sx={{ color: theme.palette.warning.dark }}/>}
      >
        <AlertTitle>ICD10 {code} {hasGuidance === true ? (<ReportIcon />) : null}</AlertTitle>
        <Typography
          variant="body2"
          title={description}
        >
          {description}
        </Typography>

      {
        hccs.map(x => (
          <HccDisplayInfo
            key={x.encodingId}
            code={x.code}
            description={x.description}
            estimatedImpactDollars={x.estimatedImpactDollars}
            type={x.type}
            version={x.version}
            theme={theme}
          />
        ))
      }
      </Alert>
    </>
  );
}

function EncodingDisplayInfo({ dx, theme }) {
  return (
    <DxDisplayInfo
      code={dx.code}
      description={dx.description}
      hccs={dx.hccs}
      hasGuidance={dx.hasGuidance}
      theme={theme}
    />
  );
}

EncodingDisplayInfo.propTypes = {
  dx: PropTypes.shape({
    encodingId: PropTypes.number.isRequired,
    code: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    hasGuidance: PropTypes.bool.isRequired,
    hccs: PropTypes.arrayOf(PropTypes.shape({
      encodingId: PropTypes.number.isRequired,
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      estimatedImpactDollars: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      version: PropTypes.string.isRequired
    }).isRequired).isRequired
  })
};

export { EncodingDisplayInfo };
